import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [visible, setVisible] = useState(false);
  const refresh = useCallback(() => {
    api.get("/store/status").then((r) => setVisible(r.data.visible)).catch(() => setVisible(false));
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <StoreContext.Provider value={{ visible, refresh }}>{children}</StoreContext.Provider>;
}

export function useStore() {
  return useContext(StoreContext);
}
